<div class="schema-list">
  <div class="schema-filter-container">
    <div class="filter-row">
      <mat-form-field subscriptSizing="dynamic" class="search-field">
        <mat-label>Search records by name</mat-label>
        <input matInput (keyup)="onSearchKeyup($event)" placeholder="e.g. Aflac" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="status-filter-field">
        <mat-label>Filter by status</mat-label>
        <mat-select [value]="statusFilter" (selectionChange)="onStatusFilterChange($event.value)">
          <mat-option value="all">All</mat-option>
          <mat-option *ngFor="let status of availableStatuses" [value]="status">
            {{ getRecordStatusConfig(status).label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        subscriptSizing="dynamic"
        class="custom-filter-field"
        *ngFor="let customFilter of getAllCustomFilters()"
      >
        <mat-label>Filter by {{ customFilter.key }}</mat-label>
        <mat-select
          [value]="getCustomFilterValue(customFilter)"
          (selectionChange)="onCustomFilterChange(customFilter, $event.value)"
        >
          <mat-option value="all">All</mat-option>
          <mat-option
            *ngFor="let value of getAvailableCustomFilterValues(customFilter)"
            [value]="value"
          >
            {{ value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button
        mat-stroked-button
        class="clear-filters-button"
        (click)="clearAllFilters()"
        [disabled]="
          !searchFilter && (!statusFilter || statusFilter === 'all') && !hasActiveCustomFilters()
        "
      >
        <mat-icon>clear</mat-icon>
        Clear Filters
      </button>
    </div>
  </div>
  <div class="schema-selection-summary" *ngIf="getSelectableRecordCount() > 0">
    <div class="selection-info">
      <span class="primary-count">
        {{ getSelectedRecordCount() }} of {{ getSelectableRecordCount() }} selectable records
        selected
      </span>
      <span *ngIf="hasHiddenSelections()" class="hidden-selections-warning">
        <mat-icon class="warning-icon">visibility_off</mat-icon>
        {{ getHiddenSelectionsCount() }} selected records hidden by current filters
      </span>
    </div>
  </div>
  <div class="schema-list-item" *ngFor="let schema of schemas">
    <div class="schema-list-item-header" (click)="toggleSchemaExpansion(schema)">
      <div class="schema-header-main">
        <div class="checkbox-container" (click)="$event.stopPropagation()">
          <mat-checkbox
            [checked]="isSchemaChecked(schema)"
            [indeterminate]="isSchemaIndeterminate(schema)"
            [disabled]="getFilteredSelectableRecords(schema).length === 0"
            (change)="toggleSchemaSelection(schema)"
            class="schema-checkbox"
            *ngIf="getFilteredSelectableRecords(schema).length > 0"
          >
          </mat-checkbox>
          <div
            class="custom-checkbox-disabled"
            *ngIf="getFilteredSelectableRecords(schema).length === 0"
          ></div>
        </div>
        <p class="schema-title">
          {{ schema.schemaName }}
        </p>
      </div>
      <div class="expand-toggle-icon">
        <mat-icon>{{ schema.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
    </div>
    <div class="schema-records-wrapper" *ngIf="schema.isExpanded">
      <div class="schema-record-list">
        <div
          class="no-records-message"
          *ngIf="getFilteredRecords(schema).length === 0 && (!!searchFilter || !!statusFilter)"
        >
          <span>No records found matching your filters in this schema</span>
        </div>
        <div class="record-list-item" *ngFor="let record of getFilteredRecords(schema)">
          <div class="record-list-item-header" (click)="toggleRecordExpansion(record)">
            <div class="record-header-main">
              <div class="checkbox-container" (click)="$event.stopPropagation()">
                <mat-checkbox
                  [checked]="record.isSelected"
                  [disabled]="!isRecordSelectable(record)"
                  (change)="toggleRecordSelection(record, schema)"
                  class="record-checkbox"
                  *ngIf="isRecordSelectable(record)"
                >
                </mat-checkbox>
                <div class="custom-checkbox-disabled" *ngIf="!isRecordSelectable(record)"></div>
              </div>
              <p class="record-title">
                {{ record.label }}
              </p>
              <div class="record-status-tags">
                <mat-chip-set>
                  <mat-chip
                    *ngFor="let status of getRecordStatuses(record)"
                    [ngClass]="getRecordStatusConfig(status).css"
                  >
                    {{ getRecordStatusConfig(status).label }}
                  </mat-chip>
                </mat-chip-set>
              </div>
            </div>
            <div class="expand-toggle-icon">
              <mat-icon>{{ record.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
          </div>
          <div class="record-comparison-wrapper" *ngIf="record.isExpanded">
            <div class="record-environments">
              <div class="record-environment-column">
                <app-json-diff [diffLines]="getQADiffLines(record)" title="QA"></app-json-diff>
              </div>
              <div class="record-environment-column">
                <app-json-diff
                  [diffLines]="getProdDiffLines(record)"
                  title="Production"
                ></app-json-diff>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
